import { ChangeDetectorRef, Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { GlobalState } from './global.state';
import { Subject, filter, map, takeUntil } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ViewportScroller } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  public showMenu: boolean = false;

  public demoMode: boolean = false;

  destroy$: Subject<boolean> = new Subject<boolean>();

  public isMobile: boolean = false;

  constructor(
    public changeDec: ChangeDetectorRef, 
    public router: Router, 
    public afAuth: AngularFireAuth, 
    public globalState: GlobalState,
    private viewportScroller: ViewportScroller,
        private renderer: Renderer2 // Use Renderer2 to manipulate DOM safely

  ){
    
    this.globalState.getShowMenu$()
    .pipe(takeUntil(this.destroy$))
    .subscribe(e => {
        this.showMenu = e;
    })

    // this.isMobile = this.FindisMobile();

    this.afAuth.user.subscribe(e => {
      if(e && e.email == "demoapp@gmail.com")
      {
        this.demoMode = true;
      }
      else{
        this.demoMode = false;
      }
    })

  }

  ngOnInit(): void {

    // 2. Set the data-brand attribute on the body explicitly here
    const brand = environment.brand || 'maptheday';
  this.renderer.setAttribute(document.documentElement, 'data-brand', brand);

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.viewportScroller.scrollToPosition([0, 0]);
    });
  }

  // private FindisMobile() {
  //   const minWidth = 768; // Minimum width for desktop devices
  //   return window.innerWidth < minWidth || screen.width < minWidth;
  // }

  closeMenu()
  {
    this.globalState.switchShowMenuOff();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  title = 'maptheday';

  goToPage(routeName: string)
  {
    this.globalState.switchShowMenuState();
    this.router.navigateByUrl(routeName);
  }

  isDarkMode()
  {
    let currentMode = localStorage.getItem("theme");

    if(!currentMode)
    {
      // by default, dark mode is on
      return true;
    }

    if(currentMode == "dark")
    {
      return true;
    }

    return false;
  }

  setDarkMode()
  {
    let currentMode = localStorage.getItem("theme");
    if(currentMode)
    { 
      if(currentMode == "dark")
      {
        localStorage.setItem("theme", "light");
        document.documentElement.setAttribute('data-theme', 'light');

      }
      else{
        localStorage.setItem("theme", "dark");
        document.documentElement.setAttribute('data-theme', 'dark');

      }

    }
    else{
      localStorage.setItem("theme", "dark");
      document.documentElement.setAttribute('data-theme', 'dark');
    }

    location.reload();
  }
  
}
